import { useStore, useUnit } from 'effector-react';
import $$api from 'models/api';
import $$auth from 'models/auth';
import { $queryParams } from 'models/location';
import { $global } from 'models/store-global';
import { useEffect } from 'react';

const useAutomaticAdvisorLinker = () => {
    const params = useStore($queryParams);
    const advisorParticipantId = params['link-advisor-id'] || localStorage.getItem('link-advisor-id');

    const isAuthorized = useUnit($global.map((state) => state.auth?.userRole || 'guest')) !== 'guest';
    const clientParticipantId = useUnit($$auth.$currentParticipant.map((p) => p?.participant_id));

    const linkToAdvisor = async () => {
        if (advisorParticipantId && clientParticipantId) {
            await $$api.advisor.linkClientToAdvisorFx({
                advisorParticipantId: +advisorParticipantId,
                clientParticipantId: clientParticipantId,
            });
            localStorage.removeItem('link-advisor-id');
            await $$api.participants.getCommunityFx(undefined);
        }
    };

    useEffect(() => {
        (async () => {
            if (advisorParticipantId) {
                if (isAuthorized && clientParticipantId) {
                    await linkToAdvisor();
                } else {
                    localStorage.setItem('link-advisor-id', advisorParticipantId);
                }
            }
        })();
    }, [advisorParticipantId, isAuthorized, clientParticipantId]);
};

export default useAutomaticAdvisorLinker;
